<script setup>
import { faCube, faSync } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { formatDate } from 'date-fns'
import { useComponentStore } from '../../../stores/component'

const componentStore = useComponentStore()

defineProps({
  item: { type: Object, required: true }
})
</script>

<template>
  <li>
    <div class="tags mb-2">
      <span class="tag app-has-yellow-background-light">
        <span class="icon">
          <FontAwesomeIcon :icon="faCube" />
        </span>
        <span>{{ componentStore.getLabel(item.subgroup_code) }}</span>
      </span>
      <span v-for="(date, i) of item.replacement_dates" :key="i" class="tag">
        <span class="icon">
          <FontAwesomeIcon :icon="faSync" />
        </span>
        <span>{{ formatDate(new Date(date), 'dd/MM/yyyy') }}</span>
      </span>
    </div>
    <ul v-if="item.children.length" class="mt-0">
      <ComponentTreeItem v-for="child of item.children" :key="child.id" :item="child" />
    </ul>
  </li>
</template>
